import ContactForm from '@components/undock/forms/contact'
import Module, { ModuleHeadline, themesMap } from '@components/undock/modules'
import {
  Container,
  ContentWrapper,
  FormWrapper,
  InfoHeader,
  InfoWrapper,
} from '@components/undock/modules/contact/style'
import { ModuleI } from '@lib/contentful/entries'
import { FunctionComponent } from 'react'

interface ContactModulePropsI extends ModuleI {}

const ContactModule: FunctionComponent<ContactModulePropsI> = ({
  id = 'NO_ID_PROVIDED',
}) => {
  return (
    <Module id={id} theme={themesMap.light} style={{ flexWrap: 'wrap' }}>
      <Container>
        <ContentWrapper>
          <ModuleHeadline>Talk To Us</ModuleHeadline>
          <p>
            We’ll help you find the right plan and pricing for you or your
            business
          </p>
        </ContentWrapper>
      </Container>
      <Container>
        <FormWrapper>
          <ContactForm />
        </FormWrapper>
        <InfoWrapper>
          <InfoHeader>
            <img src="/icons/icon-location.svg" />
            Office Address
          </InfoHeader>
          <p>
            415 Madison Ave, 4th Fl
            <br />
            New York, NY 10017
          </p>
        </InfoWrapper>
      </Container>
    </Module>
  )
}

export default ContactModule
